import { FC } from 'react'
import SecondaryButton, {
  ISecondaryButton,
} from '../SecondaryButton/SecondaryButton'
import classNames from 'classnames'
import cn from './index.module.css'

interface IPrimaryButton extends ISecondaryButton {}

const PrimaryButton: FC<IPrimaryButton> = ({ ...props }) => {
  return (
    <SecondaryButton
      {...props}
      className={classNames(cn.primaryButton, props.className)}
    />
  )
}

export default PrimaryButton
